import React from "react";
import AdminCategories from "../../components/admin/AdminCategories";
import AdminTags from "../../components/admin/AdminTags";


const AdminTagsCategories = () => {
  return (
    
    <div className="admin-messages-container">
      <h2>Manage Categories & Tags</h2>

      <div className="tags-categories-wrapper">

      {/* ✅ Categories Section */}
      <div className="admin-section">
        <h3>Categories</h3>
        <AdminCategories />
      </div>

      {/* ✅ Tags Section */}
      <div className="admin-section">
        <h3>Tags/Attributes</h3>
        <AdminTags />
      </div>
      </div>

    </div>
  );
};

export default AdminTagsCategories;
